// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancel-btn[data-v-3350c31e]{border:0;background-color:#01426b;color:#fff;border-radius:30px;padding:2px 10px;margin-top:10px}", ""]);
// Exports
module.exports = exports;
